import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Silenciar error benigno de ResizeObserver (evita el overlay de CRA en dev)
const _roError = "ResizeObserver loop completed with undelivered notifications";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(_roError)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrar el Service Worker sólo en producción (evita interferir con hot-reload de CRA).
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] no se pudo registrar el service worker:', err);
    });
  });
}
